import BtnList from './lib/BtnList/BtnList';
import { loadImg, loadJs, getImageSizeByContainer } from "./utils/common";
import { KONVA_URL } from './constantsOption';
import { DEFAULT_STAGE_OPTION } from './renderOption';
import { MODE_TYPE } from './enums/index';
import LineMode from './lib/Mode/LineMode';
import CircleMode from './lib/Mode/CircleMode';
import TemplateMode from './lib/Mode/TemplateMode';
import konva from './assets/konva.min.js';
import psBgPng from './assets/psBg.png';

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    config: {},
    content: null,
    stage: null,
    btnInstance: null,
    isPointerMove: false,
    modeInstance: null,
    canvasContent: null,
    stageSize: {},
    masker: null,
    originImgData: {
      width: 0,
      height: 0,
      originImg: null
    },
    curDrawLayerIndex: 0,
    layers: {
      imgLayer: null,
      circleLayer: null,
      maskerLayer: null,
    },
    shapes: {
      circles: {
        inner: null,
        outer: null,
      },
      bg: null
    },
    stageOption: {},
    errorData: {
      status: false,
      errorList: []
    }
  };
}

/**
 * 图片绘制组件
 */
class DrawCanvas {
  constructor(content, props) {
    const data = props || {};

    this.init(content, data);
  }

  data = getDefaultData();

  async init(content, props) {
    this.initConfig(props, content);
    // 加载js和image
    // await this.initJs();
    window.Konva = konva;
    await this.initImg(props);

    // 错误处理 出错等级后续补齐
    if (this.data.errorData.status === true) return;

    // 清除子节点
    this.clearChildrenDom();
    // 创建按钮列表
    this.createBtnList();
    // 创建canvas外壳
    this.createCanvasContainer();
    // 创建canvas
    this.initCanvas(content);
    // 创建暗色蒙版
    this.createMasker();
    // 根据传入线还是圆的模式分布
    this.initMode(props);
    // 执行onready
    this.onReady(props);
    // 注册resize事件
    this.registResize();
  }

  initConfig(props, content) {
    this.data.config = {
      ...this.data.config,
      ...props
    }

    this.data.content = document.querySelector(content);
    
    this.data.stageOption = Object.assign({}, props.stageOption || {}, DEFAULT_STAGE_OPTION);
  }

  initMode(props) {
    const initData = props.initData || {};
    const modeProps = {
      content: this.data.content,
      stage: this.data.stage,
      btnInstance: this.data.btnInstance,
      canvasContent: this.data.canvasContent,
      stageMapId: props.firstLayerId || null,
      onActive: props.onActive,
      drawOption: props.drawOption,
      initData: initData.modeData, // 历史数据 用来回显驱动初始化图像
      historyStageSize: initData.stageSize || this.data.stageSize,
      stageSize: this.data.stageSize,
      bgSize: {
        width: this.data.shapes.bg.canvasWidth,
        height: this.data.shapes.bg.canvasHeight
      },
      historyBgSize: initData.bgSize || {
        width: this.data.shapes.bg.canvasWidth,
        height: this.data.shapes.bg.canvasHeight
      },
    }

    const modeType = initData.modeType || props.modeType;

    this.data.config.modeType = modeType;
    // console.log('modeType', modeType);
    switch (modeType) {
      // 线模式
      case MODE_TYPE.LINE:
        this.data.modeInstance = new LineMode(modeProps); // new LineMode(modeProps);
        break;
      // 圈模式
      case MODE_TYPE.CIRCLE:
        this.data.modeInstance = new CircleMode(modeProps);
        break;
      case MODE_TYPE.TEMPLATE:  
        this.data.modeInstance = new TemplateMode(modeProps);
        break;
      default:
        break;
    }
  }

  async initJs() {
    try {
      await loadJs(konva);
    } catch (e) {
      console.log('js加载失败');

      this.data.errorData.status = true;
      this.data.errorData.errorList.push({
        level: 0,
        msg: 'js加载失败'
      });
    }
    
  }
  /**
   * 初始化图片数据 获取长宽数据
   * @param {*} data 
   */
  async initImg(props) {
    const { originImgData } = props;
    const initData = props.initData || {};
    let url = (initData.bg || {}).url || props.url || initData.url || initData.bg; // 优先历史记录(编辑功能)中的数据
    let img = null;

    try {
      if (originImgData && originImgData.tagName === 'IMG') {
        img = originImgData;
      } else if (!!url) {
        img = await loadImg(url);
      } else {
        throw new Error('请传递正确url或者originImgData对象');
      }
      // img = await loadImg(url);
      this.data.originImgData = {
        ...this.data.originImgData,
        width: initData.width || img.width || 0, // 优先历史记录(编辑功能)中的数据
        height: initData.height || img.height || 0, // 优先历史记录(编辑功能)中的数据
        originImg: img
      }

      return img
    } catch (e) {
      console.log('图片加载失败');

      this.data.errorData.status = true;
      this.data.errorData.errorList.push({
        level: 1,
        msg: '图片加载失败'
      });
    }
  }

  // 清空所有dom
  clearChildrenDom() {
    this.data.content.innerHTML = '';
  }

  registResize() {   
    this.resize = () => {
      const canvasBox = document.querySelector('#preview_canvas');
      if (!canvasBox) return;
      
      this.data.stage.width(canvasBox.offsetWidth)
      this.data.masker && this.data.masker.width(canvasBox.offsetWidth);
      this.data.layers.maskerLayer.draw();
    }

    window.addEventListener('resize', this.resize);
  }

  removeRegist() {
    this.data.stage.destroy();

    window.removeEventListener('resize', this.resize);

    const allDrawLayer = this.data.modeInstance.getDrawLayerMap();

    if (!this.data.modeInstance) return;

    allDrawLayer.forEach((mapValue) => {
      mapValue.lampNodeQueue = null;
      mapValue.lineNodeQuene = null;
    });

    console.log('lampNodeQueue', this.data);
  }


  async changeBg(option) {
    const img = await this.initImg(option);
    const { originImgData, stageSize } = this.data;
    // const { originImg } = originImgData;
    const originImgWidth = img.width;
    const originImgHeight = img.height;

    const { width: canvasWidth, height: canvasHeight } = getImageSizeByContainer(
      originImgWidth,
      originImgHeight,
      stageSize.width,
      stageSize.height
    );

    this.data.shapes.bg = {
      ...(this.data.shapes.bg || {}),
      originImgWidth,
      originImgHeight,
      canvasWidth,
      canvasHeight
    };
    
    this.data.shapes.bg.node.image(img);
    this.data.shapes.bg.node.width(canvasWidth);
    this.data.shapes.bg.node.height(canvasHeight);
    this.data.layers.imgLayer.draw();
  }

  // 创建canvas容器
  createCanvasContainer() {
    const { width, height } = this.data.config;
    const canvasContainer = document.createElement('div');
    const btnListDom = document.querySelector('.draw-canvas_btn-list');
    const btnListHeight = btnListDom ? btnListDom.offsetHeight : 0;

    canvasContainer.id = 'draw-canvas-container';

    const canvasContainerWidth = width || this.data.content.offsetWidth;
    const canvasContainerHeight = (height || this.data.content.offsetHeight) - btnListHeight; // 65为btnlist高度

    canvasContainer.style.width = canvasContainerWidth + 'px';
    canvasContainer.style.height = canvasContainerHeight + 'px';

    canvasContainer.style.background = `url(${psBgPng}) repeat`;
    canvasContainer.style['background-size'] = '40px 40px'

    this.data.content.appendChild(canvasContainer);

    this.data.canvasContent = canvasContainer;
    this.data.stageSize = {
      width: canvasContainerWidth,
      height: canvasContainerHeight
    }
  }

  // 创建按钮组
  createBtnList() {
    // 未来作为按钮扩展配置
    const { btnConfig } = this.data.config;

    if (btnConfig === null) return;

    this.data.btnInstance = new BtnList({
      content: this.data.content,
      btnConfig,
      handlerDelete: this.handlerAllDelete, // 删除所有
      handlerDeleteLast: this.handlerDeleteLast, // 删除最后一条点线
    });
  }

  // 创建canvas画布
  initCanvas() {
    const { originImgData, stageSize } = this.data;

    const stage = new window.Konva.Stage({
      container: `#draw-canvas-container`, //指定放置舞台的容器
      width: stageSize.width, //设置宽高
      height: stageSize.height,
    })

    this.data.layers.circleLayer = new window.Konva.Layer();
    this.data.stage = stage;

    stage.add(this.data.layers.circleLayer);

    this.initBg();
  }

  initBg() {
    const { originImgData, stageSize } = this.data;
    const { originImg } = originImgData;
    const originImgWidth = originImg.width;
    const originImgHeight = originImg.height;

    this.data.layers.imgLayer = new window.Konva.Layer(); //创建层 layer
    const { width: canvasWidth, height: canvasHeight } = getImageSizeByContainer(
      originImgWidth,
      originImgHeight,
      stageSize.width,
      stageSize.height
    );

    this.data.stage.add(this.data.layers.imgLayer);

    const image = new Konva.Image({
      x: 0,
      y: 0,
      image: originImg,
      width: canvasWidth,
      height: canvasHeight
    });

    this.data.shapes.bg = {
      node: image,
      originImgWidth,
      originImgHeight,
      canvasWidth,
      canvasHeight
    };
    this.data.layers.imgLayer.add(image);
    this.data.layers.imgLayer.draw();
  }

  // 创建masker
  createMasker() {
    const { width, height } = this.data.stageSize;
    const { fill, opacity, x, y } = this.data.stageOption.masker;

    const maskerLayer = new window.Konva.Layer();
    const masker = new Konva.Rect({
      width,
      height,
      fill,
      opacity,
      x,
      y
    });

    this.data.masker = masker;
    this.data.layers.maskerLayer = maskerLayer;
    this.data.stage.add(maskerLayer);
    this.data.layers.maskerLayer.add(masker);
    this.data.layers.maskerLayer.draw();
  }

  // onReady
  onReady(props) {
    const { onReady } = props;

    onReady instanceof Function && onReady();
  }

  // 设置激活当前图层 若没有该图层 内部会自动创建
  setCurLineLayerIndex(mapId) {
    console.log('设置id 2', mapId)
    this.data.modeInstance &&
      this.data.modeInstance.setCurLineLayerIndex(mapId);
  }

  // 增加灯
  addLamp = (num = 20, lampInfo = null, isRender = true) => {
    this.data.modeInstance.setLampInfo(lampInfo);
    this.data.modeInstance.addLamp(Number(num), isRender);
  }

  // 获取所有灯位的颜色
  getColors = () => {
    const {
      node,
      originImgWidth,
      originImgHeight,
      canvasWidth,
      canvasHeight
    } = this.data.shapes.bg;
    const ctx = node.getCanvas().context;
    const colors = {};
    const drawLayerMap = this.data.modeInstance.getDrawLayerMap();

    drawLayerMap.forEach((mapValue, mapKey) => {
      const lampPosition = this.data.modeInstance.getAllLampPosition(mapKey);
      const devicePixelRatio = window.devicePixelRatio || 1;

      const colorData = lampPosition.map(pos => {
        const _x = Math.floor(pos.x * devicePixelRatio);
        const _y = Math.floor(pos.y * devicePixelRatio);
        const canvasData = ctx.getImageData(_x, _y, 1, 1);
  
        const { data } = canvasData || [];
  
        return {
          rgba: `${data[0]}, ${data[1]}, ${data[2]}, ${data[3]}`,
          ...pos,
          canvasWidth,
          originImgWidth,
          canvasHeight,
          originImgHeight,
          _x,
          _y
        }
      });

      colors[mapKey] = colorData;
    });

    console.log('colors', colors);
    
    return colors;
  }

  // 获取上传服务端的数据
  getSaveData = () => {
    const modeData = this.data.modeInstance.getSaveData();
    const { originImgData } = this.data;
    const saveData = {
      bg: {
        url: '',
        width: originImgData.width,
        height: originImgData.height
      },
      modeType: this.data.config.modeType,
      modeData,
      stageSize: this.data.stageSize,
      bgSize: {
        width: this.data.shapes.bg.canvasWidth,
        height: this.data.shapes.bg.canvasHeight,
      },
      appSize: this.data.stageSize,
    }

    return saveData;
  }

  // 删除最后一条线
  handlerDeleteLast = () => {
    this.data.modeInstance.deleteLastLine && this.data.modeInstance.deleteLastLine();
  }

  // 删除所有线
  handlerAllDelete = () => {
    this.data.modeInstance.deleteAllLine();
  }

  // 均分
  divideEqually = () => {
    console.log('this.data.modeInstance', this.data.modeInstance, this.data);
    
    this.data.modeInstance &&
    this.data.modeInstance.divideEqually &&
      this.data.modeInstance.divideEqually();
  }

  // 生成随机线条
  createRandom = (mapIds) => {
    if (this.data.config.modeType === MODE_TYPE.LINE) {
      this.data.modeInstance && this.data.modeInstance.createRandomLine(mapIds)
    }

    if (this.data.config.modeType === MODE_TYPE.CIRCLE) {
      this.data.modeInstance && this.data.modeInstance.createRandomCircle(mapIds)
    }
  }
}

export const MODE_TYPE_ENUMS = MODE_TYPE;

export default DrawCanvas;